let LabelCN = {
    zxggCN:{
        address:'地址',
        body:'内容',
        caseNo:'案号',
        closeDate:'终本日期',
        court:'法院名称',
        dataType:'数据类型',
        partys:'当事人',
        proposer:'申请人',
        sortTime:'立案日期',
        title:'标题',
        yjCode:'依据文书',
        yjdw:'依据单位',
        zxggId:'执行公告ID',
        partysCN:{
            caseStateT:'案件状态',
            caseNoKwordT:'代字',
            execMoney:'执行金额',
            idcardNo:'关联方id',
            partyType:'主体类型',
            pname:'当事人名称',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类',
        }

    },
    cpwsCN:{
        body:'内容',
        cpwsId:'裁判文书ID',
        caseNo:'案号',
        court:'法院',
        judge:'审判员',
        judgeResult:'判决结果',
        sortTime:'审结日期',
        title:'标题',
        yiju:'依据',
        partys:'当事人',
        trialProcedure:'审理状态',
        dataType:'数据类型',
        partysCN:{
            birthday:'当事人出生日期',
            caf:'受理费',
            caseCauseT:'案由',
            caseNoKwordT:'代字',
            caseTypeT:'文书类型',
            courtRankT:'法院等级',
            courtTypeT:'法院类型',
            lawOffice:'律师事务所',
            lawyer:'委托律师（辩护人）',
            partyFeeT:'判决金额',
            partyPositionT:'诉讼地位（原审）',
            partyResult:'胜负关系',
            partyTitleT:'当前称号',
            partyType:'主体类型',
            pname:'当事人名称',
            boHui:'驳回标签',
            cdk:'查冻扣标签',
            chaiChu:'拆除标签',
            cheSu:'撤诉标签',
            diaoXiao:'吊销标签',
            faKuan:'罚款标签',
            guoHu:'过户标签',
            jieChuCDK:'解除查冻扣标签',
            jingGao:'警告标签',
            juLiu:'拘留标签',
            moShou:'没收标签',
            piaoJuWX:'票据无效标签',
            poChanCZ:'破产重整标签',
            pochanHJ:'破产和解标签',
            poChanQS:'破产清算标签',
            qangZhi:'强制执行标签',
            qangZhiZX:'强制注销标签',
            qianChu:'迁出标签',
            queRenWF:'确认违法标签',
            queRenWX:'确认无效标签',
            shiXin:'失信标签',
            tingChanTY:'停产停业标签',
            zhongBen:'终结本次执行程序标签',
            zhongZhi:'中止执行标签',
            zjzx:'终结执行标签',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类'
        }
    },
    ktggCN:{
        ktggId:'开庭公告ID',
        body:'内容',
        caseNo:'案号',
        court:'法院',
        courtroom:'法庭',
        judge:'法官',
        organizer:'组织者',
        sortTime:'开庭时间',
        title:'标题',
        partys:'当事人',
        dataType:'数据类型',
        partysCN:{
            caseCauseT:'案由',
            caseNoKwordT:'代字',
            courtRankT:'法院等级',
            courtTypeT:'法院类型',
            partyPositionT:'诉讼地位（原审）',
            partyTitleT:'当前称号',
            partyType:'主体类型',
            pname:'当事人名称',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类',

        }
    },
    shixinCN:{
        shixinId:'失信公告ID',
        body:'内容',
        caseNo:'案号',
        court:'法院名称',
        postTime:'发布时间',
        sortTime:'立案时间',
        yiwu:'义务',
        yjCode:'依据文号',
        yjdw:'依据单位',
        partys:'当事人',
        dataType:'数据类型',
        partysCN:{
            age:'年龄',
            caseNoKwordT:'代字',
            idcardNo:'关联方id',
            jtqx:'具体情形',
            lxqkT:'履行情况',
            money:'涉案金额',
            partyType:'主体类型',
            pname:'当事人名称',
            province:'省份',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类',
        }
    },
    fyggCN:{
        fyggId:'法院公告ID',
        body:'内容',
        caseNo:'案号',
        court:'法院名称',
        layout:'版面',
        sortTime:'立案时间',
        partys:'当事人',
        dataType:'数据类型',
        title:'标题',
        partysCN:{
            caseCauseT:'案由',
            caseNoKwordT:'代字',
            courtRankT:'法院等级',
            courtTypeT:'法院类型',
            ggTypeT:'公告类型',
            partyPositionT:'诉讼地位（原审）',
            partyTitleT:'当前称号',
            partyType:'主体类型',
            pname:'当事人名称',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类',
        }
    },
    ajlcCN:{
        ajlcId:'案件流程ID',
        actionObject:'诉讼标的',
        body:'内容',
        caseNo:'案号',
        courtS:'法院',
        organizer:'组织者',
        sortTime:'案件时间',
        title:'标题',
        partys:'当事人',
        dataType:'数据类型',
        partysCN:{
            ajlcStatusT:'案件状态',
            caseCauseT:'案由',
            caseNoKwordT:'代字',
            courtRankT:'法院等级',
            courtTypeT:'法院类型',
            partyPositionT:'诉讼地位（原审）',
            partyTitleT:'当前称号',
            partyType:'主体类型',
            pname:'当事人名称',
            trialProcedureS:'审理状态',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类',
        }
    },
    bgtCN:{
        bgtId:'曝光台ID',
        body:'内容',
        caseNo:'案号',
        court:'法院名称',
        proposer:'申请人',
        sortTime:'立案时间',
        title:'标题',
        yiju:'依据',
        yjCode:'依据文书',
        partys:'当事人',
        dataType:'数据类型',
        partysCN:{
            address:'地址',
            caseCauseT:'案由',
            caseNoKwordT:'代字',
            execMoney:'标的金额',
            idcardNo:'关联方id',
            partyType:'主体类型',
            pname:'当事人名称',
            signalDesc:'信号描述',
            signalRating:'信号等级',
            signalRuleNo:'规则编码',
            signalRuleVersion:'规则版本',
            ruleMainType:'大类',
            ruleSubType:'小类',
        }
    },
    sifacdkCN:{
        sifacdkId:'司法查冻扣ID',
        body:'正文',
        sortTime:'审结时间',
        eventDate:'事件日期',
        objectName:'标的名称',
        court:'审理法院',
        pname:'当事人',
        title:'标题',
        action:'资产类别',
        caseNo:'案号',
        objectType:'标的类型',
        postTime:'发布时间',
        money:'金额（元）',
        dataType:'数据类型',
    },
    pmggCN:{
        pmggId:'拍卖公告ID',
        title:'拍卖公告标题',
        pname:'拍卖标的所有权人',
        idCardNo:'所有权人证件号码',
        address:'标的物详细地址',
        auctionAmount:'标的物起拍价',
        auctionType:'标的物性质',
        lot:'标的物名称',
        lotInfo:'拍卖标的物详细描述',
        powerNo:'拍卖标的权证号',
        measure:'标的物面积',
        postTime:'发布日期',
        sortTime:'拍卖时间',
        court:'执行法院',
        body:'源码/正文',
        dataType:'数据类型'
    },
    satparty_qsCN:{
        satparty_qsId:'欠税公告ID',
        authority:'局（政府单位）',
        body:'内容',
        eventName:'事件名称',
        legalRepresentative:'关联方名称',
        lrIdcard:'关联方id',
        money:'欠税金额',
        pname:'企业名称',
        postTime:'发布时间',
        sortTime:'欠税时间',
        taxCategory:'税种',
        taxpayerId:'税务登记号',
        title:'标题',
        dataType:'数据类型',
        authorityRank:'税务局等级',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    satparty_chufaCN:{
        satparty_chufaId:'涉税处罚公示ID',
        authority:'局（政府单位）',
        body:'内容',
        eventResult:'事件结果',
        legalRepresentative:'关联方名称',
        lrIdcard:'关联方id',
        money:'处罚金额',
        pname:'企业名称',
        postTime:'发布时间',
        sortTime:'处罚时间',
        taxpayerId:'税务登记号',
        title:'标题',
        dataType:'数据类型',
        eventName:'事件名称',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    satparty_fzcCN:{
        satparty_fzcId:'税务非正常户ID',
        authority:'局（政府单位）',
        body:'内容',
        eventName:'事件名称',
        eventResult:'事件结果',
        legalRepresentative:'关联方名称',
        lrIdcard:'关联方id',
        pname:'企业名称',
        postTime:'发布时间',
        sortTime:'认定时间',
        taxpayerId:'税务登记号',
        title:'标题',
        dataType:'数据类别',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    satparty_xinCN:{
        satparty_xinId:'纳税信用等级ID',
        authority:'局（政府单位）',
        body:'内容',
        eventResult:'事件结果（级别）',
        legalRepresentative:'企业关联方名称',
        pname:'企业名称',
        postTime:'发布时间',
        sortTime:'评定时间',
        taxpayerId:'税务登记号',
        title:'标题',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    epbpartyCN:{
        epbpartyId:'环保处罚ID',
        authority:'局（政府单位）',
        body:'内容',
        caseNo:'案号',
        eventResult:'事件结果',
        eventYiju:'事件依据',
        legalRepresentative:'关联人名称',
        money:'处罚金额',
        pname:'企业名称',
        postTime:'发布时间',
        sortTime:'处罚时间',
        title:'标题',
        dataType:'数据类型',
        eventName:'事件名称（类型）',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    epbparty_jkqyCN:{
        epbparty_jkqyId:'重点监控企业名单ID',
        eventName:'事件名称',
        eventType:'事件类型',
        pname:'企业名称',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    epbparty_zxjcCN:{
        epbparty_zxjcIdCN:'环保企业自行检测结果ID',
        creditNo:'企业ID/组织机构代码/统一社会信用代码',
        dealWay:'污染物排放方式',
        dealWhere:'排放方向',
        density:'监测结果',
        eventResult:'事件结果',
        monitorWay:'监测方式',
        pname:'企业名称',
        pollutant:'监测指标/污染项目',
        sortTime:'监测时间',
        standard:'标准限值',
        station:'监测点位名称',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    custom_qyCN:{
        custom_qyId:'海关企业信息ID',
        bgyxq:'报送有效期',
        body:'内容',
        cancelSign:'海关注销标志',
        category:'经营类别',
        creditNo:'组织机构代码/统一社会信用代码',
        custom:'注册海关',
        etype:'跨境贸易电子商务类型',
        industry:'行业种类',
        jjqh:'经济区划',
        nbqk:'年报情况',
        pname:'企业名称',
        regAddress:'工商注册地址',
        regNo:'海关注册编码',
        sortTime:'注册时间',
        title:'标题',
        tsmyq:'特殊贸易区',
        zxqh:'行政区划',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    custom_xukeCN:{
        custom_xukeId:'海关许可ID',
        authority:'局（政府机构）',
        body:'内容',
        endTime:'有效期至',
        eventItem:'海关许可事项',
        legalRepresentative:'企业关联方名称',
        pname:'企业名称',
        postTime:'发布时间',
        title:'标题',
        xkNo:'许可文书号',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    custom_creditCN:{
        custom_creditId:'海关信用等级ID',
        authority:'局（政府机构）',
        body:'内容',
        creditRank:'信用等级',
        pname:'企业名称',
        regNo:'海关注册编码',
        sortTime:'认定年份',
        title:'标题',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    custom_punishCN:{
        custom_punishId:'海关处罚信息ID',
        authority:'局（政府机构）',
        body:'内容',
        creditNo:'组织机构代码/统一社会信用代码',
        eventType:'事件类型',
        ggType:'公告类型',
        legalRepresentative:'企业关联方名称',
        pname:'企业名称',
        postTime:'发布时间',
        regNo:'海关注册编码',
        sortTime:'处罚时间',
        title:'标题',
        yj:'依据',
        yjCode:'处罚决定文书号',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    credit_chufaCN:{
        credit_chufaId:'信用处罚ID',
        yjCode:'行政处罚决定书文号',
        creditNo:'信用代码',
        legalRepresentative:'关联方名称',
        lrIdcard:'关联方id',
        eventDesc:'处罚事由',
        eventYiju:'处罚依据',
        eventType:'处罚类别',
        eventResult:'处罚结果',
        authority:'处罚机关',
        district:'地区代码',
        postTime:'信息发布时间',
        sortTime:'处罚日期',
        title:'公告标题',
        pname:'被处罚人',
        body:'源码/正文',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    credit_xukeCN:{
        credit_xukeId:'信用许可ID',
        yjCode:'行政许可决定书文号',
        creditNo:'信用代码',
        legalRepresentative:'关联方名称',
        lrIdcard:'关联方id',
        eventType:'审核类型/审批类别',
        eventItems:'内容许可',
        district:'地方编码',
        authority:'许可机关',
        caseStatus:'状态/登记状态',
        postTime:'信息发布时间',
        sortTime:'许可日期',
        endTime:'许可截止日期',
        title:'公告标题',
        pname:'当事人',
        body:'源码/正文',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    jobCN:{
        jobId:'招聘数据ID',
        sortTime:'招聘时间',
        body:'正文',
        startDate:'招聘开始时间',
        stopDate:'招聘截止时间',
        postDate:'发布时间',
        welfare:'薪酬福利',
        comIndustry:'公司行业',
        title:'标题',
        degree:'学历',
        address:'地址',
        comName:'公司名称',
        salary:'薪资待遇',
        recruitNum:'招聘人数',
        salaryN:'平均薪资',
        siteName:'招聘信息发布网站',
        industry:'公司主营业务',
        dataType:'数据类型'
    },
    newsCN:{
        newsId:'新闻媒体id',
        body:'内容',
        title:'标题',
        pname:'当事人',
        sortTime:'发布时间',
        dataType:'数据类型',
        tags:'标签',
        summary:'摘要',
        partyTitle:'当事人标题'
    },
    fdapartyCN:{
        fdapartyId:'食药监&市场监管ID',
        authority:'局（政府机构）',
        body:'内容',
        eventDate:'事件日期',
        eventResult:'事件结果',
        eventType:'事件类型',
        pname:'企业名称',
        postTime:'发布时间',
        sortTime:'处罚时间',
        title:'标题',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    pbcpartyCN:{
        pbcpartyId:'央行行政处罚id',
        sortTime:'处罚时间',
        eventDesc:	'事件描述',
        authority:	'管理机关',
        body:	'内容',
        eventYiju:	'事件依据',
        caseNo:	'公告编号',
        eventName:	'事件名称',
        legalRepresentative:	'关联方名称',
        eventResult:	'事件结果',
        eventDate:	'事件日期',
        pname:	'被查企业',
        eventType:	'事件结果',
        title:	'标题',
        postTime:	'发布时间',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    pbcparty_cbrcCN:{
        pbcparty_cbrcId:	'银保监会行政处罚id',
        sortTime:	'处罚时间',
        eventDesc:	'事件描述',
        authority:	'管理机关',
        body:	'内容',
        eventYiju:	'事件依据',
        caseNo:	'公告编号',
        eventName:	'事件名称',
        legalRepresentative:	'关联方名称',
        eventResult:	'事件结果',
        eventDate:	'事件日期',
        pname:	'被查企业',
        eventType:	'事件结果',
        title:	'标题',
        postTime:	'发布时间',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类',
    },
    pbcparty_csrc_chufaCN:{
        pbcparty_csrc_chufaId:	'证监处罚公示id',
        eventName:	'公告类型',
        caseNo:	'处罚决定书文号',
        eventDesc:	'处罚事由',
        eventYiju:	'处罚依据',
        company:	'当事人所属单位',
        legalRepresentative:	'关联方名称关联方名称 /负责人',
        authority:	'处罚机关',
        eventResult:	'处罚结果/行政处罚决定',
        sortTime:	'处罚时间',
        postTime:	'发布时间',
        pname:	'违规主体名称',
        title:	'公告标题/案件名称',
        body:	'源码/正文',
        dataType:'数据类型',
        signalDesc:'信号描述',
        signalRating:'信号等级',
        signalRuleNo:'规则编码',
        signalRuleVersion:'规则版本',
        ruleMainType:'大类',
        ruleSubType:'小类'
    },
    safe_chufaCN:{
        safe_chufaId:	'外汇局处罚id',
        caseNo:	'处罚文书文号',
        address:	'注册地',
        authority:	'查处机构',
        caseCause:	'违规行为',
        yiju:	'处罚依据',
        eventResult:	'处罚结果',
        companyNo:	'机构代码',
        money:	'处罚金额（单位：万元人民币）',
        sortTime:	'处罚时间',
        pname:	'违规主体名称',
        body:	'源码/正文',
        dataType:	'数据类型',
        ruleMainType:	'大类',
        ruleSubType:	'小类',
        signalDesc:	'信号描述',
        signalRating:	'信号等级',
        signalRuleNo:	'规则编码',
        signalRuleVersion:	'规则版本'
    },
    xzhmdCN:{
        xzhmdId:	'受惩黑名单id',
        sortTime:	'处罚时间',
        idcardNo:	'组织机构代码',
        sourceName:	'来源名称',
        province:	'归属地域',
        eventName:	'事件名称',
        pname:	'被查企业',
        dataType:	'数据类型',
        ruleMainType:	'大类',
        ruleSubType:	'小类',
        signalDesc:	'信号描述',
        signalRating:	'信号等级',
        signalRuleNo:	'规则编码',
        signalRuleVersion:	'规则版本'
    },
    company_gqczCN:{
        company_gqczId:	'股权出质id',
        regCode:	'登记编号',
        zqr:	'质权人',
        zcrIdCard:	'出质人证照/证件号码',
        stockNum:	'出质股权数额',
        zqrIdCard:	'质权人证照/证件号码',
        companyStatus:	'状态',
        czr:	'出质人',
        cancelReason:	'注销原因',
        sortTime:	'股权出质设立登记日期',
        endTime:	'注销日期',
        pname:	'企业名称',
        dataType:	'数据类型',
        ruleMainType:	'大类',
        ruleSubType:	'小类',
        signalDesc:	'信号描述',
        signalRating:	'信号等级',
        signalRuleNo:	'规则编码',
        signalRuleVersion:	'规则版本'
    },
    company_dcdyCN:{
        company_dcdyId:	'动产抵押id',
        regCode:	'登记编号',
        authority:	'登记机关',
        bdbzqNum:	'被担保债权数额',
        dyqrName:	'抵押权人名称',
        dyqrCard:	'抵押权人证照类型',
        creditNo:	'抵押权人-证照号码',
        address:	'住所地',
        zzqType:	'被担保主债权信息-种类',
        zzqDesc:	'被担保主债权信息-担保的范围',
        zzqNum:	'被担保主债权信息-数额',
        zzqCurrency:	'被担保主债权信息-币种',
        zzqDate:	'被担保主债权信息-履行债务的期限',
        zzqMark:	'被担保主债权信息-备注',
        dywDesc:	'抵押物信息-数量，质量，状况，所在地等情况',
        changeDesc:	'变更信息',
        sortTime:	'登记日期',
        pname:	'企业名称',
        dataType:	'数据类型',
        ruleMainTyp:	'大类',
        ruleSubType:	'小类',
        signalDesc:	'信号描述',
        signalRating:	'信号等级',
        signalRuleNo:	'规则编码',
        signalRuleVersion:	'规则版本'
    },
    credit_ztbcfCN:{
        credit_ztbcfId:	'招投标行政处罚id',
        authority:	'处罚机构',
        body:	'正文',
        caseFact:	'违法事实',
        caseNo:	'字号',
        companyAddress:	'地址',
        legalRepresentative:	'关联方名称/联系人',
        lrIdcard:	'关联方id',
        pname:	'当事人',
        creditNo:	'统一社会信用代码/组织机构代码',
        postTime:	'发布日期',
        projectName:	'项目名称',
        projectNo:	'项目编号',
        publishing:	'发布机构',
        punishBasis:	'处罚依据',
        punishResult:	'处罚结果',
        punishType:	'处罚类别',
        caseCause:	'处罚事由',
        sortTime:	'处罚决定日期',
        title:	'标题',
        dataType:	'数据类型'
    },
    credit_tsclCN:{
        credit_tsclId:	'投诉处理Id',
        authority:	'执法机关',
        body:	'正文',
        caseNo:	'字号',
        closeTime:	'评审日期',
        comAddress:	'投诉人地址',
        complaintMatter:	'投诉事项',
        complaintResult:	'投诉结果',
        comRepPer:	'投诉人负责人',
        complainant:	'投诉人',
        postTime:	'发布日期',
        projectName:	'项目名称',
        projectNo:	'项目编号',
        punishBasis:	'处理依据',
        punishResult:	'处理结果',
        related:	'相关当事人',
        relatedAddress:	'相关当事人地址',
        relRepPer:	'相关当事人负责人',
        resAddress:	'被投诉人地址',
        pname:	'被投诉人',
        resRepPer:	'被投诉负责人',
        sortTime:	'投诉日期',
        title:	'标题',
        dataType:	'数据类型'
    },
    credit_sxxwCN:{
        credit_sxxwId:	'失信记录Id',
        authority:	'执法单位',
        body:	'正文',
        caseCause:	'违法事实',
        caseNo:	'字号',
        closeTime:	'公布截止日期',
        companyAddress:	'地址',
        creditNo:	'统一社会信用代码/组织机构代码',
        legalRepresentative:	'关联方名称/联系人',
        lrIdcard:	'关联方id',
        pname:	'当事人',
        postTime:	'发布日期',
        publishing:	'发布机构',
        publishTime:	'publishTime',
        punishBasis:	'处罚依据',
        punishClosingDate:	'处罚截止日期',
        punishResult:	'处罚结果',
        sortTime:	'处罚决定日期',
        title:	'标题',
        dataType:	'数据类型'
    },
    credit_jdcfCN:{
        credit_jdcfId:	'监督处罚/检查处罚Id',
        agent:	'委托代理人/授权代表',
        agentAddress:	'委托代理人地址',
        agentIdcard:	'委托代理人关联方id',
        authority:	'处罚机构',
        body:	'正文',
        caseFact:	'违法事实/检查结论',
        caseNo:	'字号',
        closeTime:	'决定书到期日期',
        comAddress:	'投诉人地址',
        complainant:	'投诉人',
        complaintMatter:	'投诉事项',
        complaintResult:	'投诉结果',
        comRepPer:	'投诉人关联方名称',
        ggTime:	'采购信息公告日期',
        lrIdcard:	'投诉人关联方名称关联方id',
        pname:	'被投诉人/当事人/被检查单位',
        postTime:	'发布日期',
        projectName:	'项目名称',
        projectNo:	'项目编号',
        projectRepPer:	'项目负责人',
        publishing:	'发布单位/来源',
        punishBasis:	'处理依据',
        punishDate:	'决定日期',
        punishResult:	'处理结果',
        related:	'相关供应商',
        relatedAddress:	'供应商地址',
        relRepPer:	'供应商联系人',
        resAddress:	'被投诉人地址',
        resRepPer:	'被投诉联系人',
        reviewDate:	'评审日期',
        sortTime:	'采购结果发布日期',
        title:	'标题',
        dataType:	'数据类型',
    },
    company_dcrz_zhiyaCN:{
        company_dcrz_zhiyaId:	'上市公司-质押ID',
        ggbh:	'公告编号',
        gslx:	'公示类型',
        zqxx:	'出质标的物信息',
        czr:	'出质人',
        zqr:	'质权人',
        zyCount:	'本次标的物质押数',
        zytime:	'质押期限',
        zong_bili:	'本次质押股份占发行股份公司比例',
        now_bili:	'本次质押股份占所持股份比例',
        sortTime:	'发布日期',
        pname:	'拍卖标的所有权人',
        title:	'标题',
        body:	'正文',
        menuName:	'数据来源',
        dataType:	'数据类型'
    },
    company_dcrz_zhiyajcCN:{
        company_dcrz_zhiyajcId:	'上市公司-解质押ID',
        ggbh:	'公告编号',
        gslx:	'公示类型',
        zqxx:	'出质标的物信息',
        czr:	'出质人',
        zqr:	'质权人',
        zyCount:	'本次标的物质押数',
        zytime:	'质押期限',
        zong_bili:	'本次质押股份占发行股份公司比例',
        now_bili:	'本次质押股份占所持股份比例',
        sortTime:	'网站发布日期',
        pname:	'拍卖标的所有权人',
        title:	'标题',
        body:	'正文',
        menuName:	'数据来源',
        dataType:	'数据类型',

    },
    company_dcrz_diyaCN:{
        company_dcrz_diyaId:	'交易所-抵押ID',
        ggbh:	'公告编号',
        gslx:	'公示类型',
        zqxx:	'出质标的物信息',
        moneyKind:	'币种',
        sqmoney:	'申请金额',
        miaoshu:	'抵押物描述',
        zytime:	'质押期限',
        pgmoney:	'抵押物评估金额',
        sortTime:	'网站发布日期',
        pname:	'借款人及抵押人',
        title:	'标题',
        body:	'正文',
        menuName:	'数据来源',
        dataType:	'数据类型'
    },
    company_dcrz_diyajcCN:{
        company_dcrz_diyajcId:	'交易所-抵押解除ID',
        ggbh:	'公告编号',
        gslx:	'公示类型',
        zqxx:	'出质标的物信息',
        moneyKind:	'币种',
        sqmoney:	'申请金额',
        miaoshu:	'抵押物描述',
        zytime:	'质押期限',
        pgmoney:	'抵押物评估金额',
        sortTime:	'网站发布日期',
        pname:	'借款人及抵押人',
        title:	'标题',
        body:	'正文',
        menuName:	'数据来源',
        dataType:	'数据类型',
    },
    company_dcrz_dongjieCN:{
        company_dcrz_dongjieId:	'交易所-冻结ID',
        ggbh:	'公告编号',
        gslx:	'公示类型',
        zqxx:	'出质标的物信息',
        cyr:	'股份持有人',
        zyCount:	'冻结股数',
        now_bili:	'本次冻结股份占所持股份比例',
        zytime:	'质押期限',
        money:	'实际累计冻结金额',
        sortTime:	'网站发布日期',
        pname:	'借款人及抵押人',
        title:	'标题',
        body:	'正文',
        menuName:	'数据来源',
        dataType:	'数据类型'

    },
    company_dcrz_danbaoCN:{
        company_dcrz_danbaoId:'交易所-担保ID',
        ggbh:	'公告编号',
        beipname:	'被担保人名称',
        dblx:	'担保类型',
        dbgx:	'担保关系',
        zqxx:	'担保标的物信息',
        sqmoney:	'申请金额',
        zytime:	'担保期限',
        moneyKind:	'币种',
        thismoney:	'本次担保金额',
        pname_nei_yue_money:	'担保人对内担保余额',
        pname_wai_yue_money:	'担保人对外担保余额',
        all_yue_money:	'担保人担保余额-',
        leiji_beipname_money:	'对被担保人累计担保金额',
        leiji_nei_money:	'对内累计担保金额',
        leiji_wai_money:	'对外累计担保金额',
        leiji_all_money:	'累计担保金额（对内+对外）',
        yue_bili:	'担保人担保余额占净资产比率',
        dbwmiaoshu:	'担保物描述',
        sortTime:	'网站发布日期',
        pname:	'借款人及抵押人',
        title:	'标题',
        body:	'正文',
        menuName:	'数据来源',
        dataType:	'数据类型'

}

}
export default function (status) {
    return LabelCN[status]|| status
}



// WEBPACK FOOTER //
// ./src/filters/LabelCN.js